import { z } from "zod";

const nearmapErrorTypeValues = ["NEARMAP_UNAUTHORIZED_ACCESS", "NEARMAP_ADDRESS_OUT_OF_COVERAGE"] as const;

const nearmapErrorTypeSchema = z.enum(nearmapErrorTypeValues);
const NearmapErrorType = nearmapErrorTypeSchema.enum;
type NearmapErrorType = z.infer<typeof nearmapErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type NearmapErrors =
  | {
      errorType: typeof NearmapErrorType.NEARMAP_UNAUTHORIZED_ACCESS;
      data: { longitude: number; latitude: number; url: string };
    }
  | {
      errorType: typeof NearmapErrorType.NEARMAP_ADDRESS_OUT_OF_COVERAGE;
      data: { longitude: number; latitude: number; url: string };
    };

export const nearmapErrorDetails: Record<NearmapErrorType, ErrorDetails> = {
  [NearmapErrorType.NEARMAP_UNAUTHORIZED_ACCESS]: {
    sentryDescription:
      "Nearmap returned a 403 for coordinates inside a covered region. Either the API key is geo-restricted or Nearmap has revoked our access.",
  },
  [NearmapErrorType.NEARMAP_ADDRESS_OUT_OF_COVERAGE]: {
    sentryDescription:
      "Nearmap returned a 403 for coordinates outside any covered country (US, CA, AU, NZ). Customer likely entered an international address.",
  },
};
